<template>
  <div>
    <section class="flex items-center justify-between !px-6 py-3">
      <label class="font-medium text-black">品項資訊</label>
      <w-button
        class="hover:text-red-500 mr-1 text-gray-500"
        type="icon"
        @click="$emit('remove-entree', entree)"
      >
        <i class="icon-trash" />
      </w-button>
    </section>
    <div class="border-b border-blue-100 pb-2">
      <section class="flex items-center !px-6 py-2">
        <div class="flex-shrink-0 mr-3">
          <span class="text-gray-500">名稱</span>
          <span class="text-red-500">*</span>
        </div>
        <w-input
          class="flex-grow"
          placeholder="請輸入品項名稱"
          shape="clear"
          v-model="name"
        />
      </section>
      <section class="flex items-center !px-6 py-2">
        <div class="flex-shrink-0 mr-5">
          <span class="text-gray-500">價格</span>
          <span class="text-red-500">*</span>
        </div>
        <div class="flex items-center">
          <span class="mb-[1px] text-black">$</span>
          <w-input
            class="w-20"
            placeholder="0"
            shape="clear"
            type="number"
            v-model="price"
          />
        </div>
      </section>
      <section class="flex items-baseline !px-6 py-2">
        <div class="flex-shrink-0 mr-4">
          <span class="text-gray-500">
            說明
          </span>
        </div>
        <w-input
          :maxLength="40"
          class="flex-grow"
          placeholder="請輸入品項說明"
          shape="clear"
          show-count
          v-model="note"
        />
      </section>
      <section class="flex items-center !px-6 py-2">
        <div class="flex-shrink-0 !mr-7">
          <span class="text-gray-500">
            類別
          </span>
        </div>
        <span class="flex-grow text-black">
          {{ getCategoryNameById(entree.categoryIndex) }}
        </span>
      </section>
    </div>
    <section class="!px-6 py-2">
      <label class="font-medium text-black">客製化選項</label>
    </section>
    <div v-if="options.length || entree.options.length" class="my-6 px-4">
      <div v-if="entree.options">
        <menu-item-option-wrapper
          v-for="option in entreeOptions"
          :key="`option-editor-${option.index}`"
          :option="option"
          @remove-option="removeEntreeOption"
        />
      </div>
      <menu-item-options-selector
        :options="options"
        class="mb-4"
        @toggle-option-create-mode="$emit('toggle-option-create-mode', true)"
      />
    </div>
    <div v-else class="mt-6 !px-6">
      <p class="text-gray-500 text-sm">
        目前無客製化選項，如需客製化選項請至
        <w-button class="px-0 py-0" type="text" @click="$emit('toggle-option-create-mode', true)">
          新增客製化選項
        </w-button>
      </p>
    </div>
  </div>
</template>

<script>
import MenuItemsEditorEntreeDetails from './MenuItemsEditorEntreeDetails';

export default MenuItemsEditorEntreeDetails;
</script>

<style lang="scss" scoped>
@import 'MenuItemsEditorEntreeDetails';
</style>
